<div id="forms" class="page-layout simple fullwidth" fxLayout="column">

    <!-- HEADER -->
    <!-- <div class="header accent p-24 h-160" fxLayout="row" fxLayoutAlign="start center">
    <div fxLayout="column" fxLayoutAlign="center start">

    </div>
  </div> -->
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content">

        <!-- <div class="h1 pt-32">
      {{'REQUERIMIENTOS.CABECERA.TITULO' | translate}}
    </div> -->

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0">{{'REQUERIMIENTOS.CABECERA.TITULO' | translate}}</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <div class="horizontal-stepper-wrapper p-20">

            <div *ngIf="muestraPorcentaje" class="" fxLayout="column" fxLayoutAlign="start stretch">
                <mat-progress-bar mode="determinate" value="{{porcentajeAvance}}"></mat-progress-bar>
                <h4 class="mt-0 mb-10 midText">{{'REQUERIMIENTOS.VALIDACION.TIMELINE.PROGRESO2' | translate}} {{porcentajeAvance}}%</h4>
            </div>

            <!-- HORIZONTAL STEPPER EXAMPLE -->
            <mat-horizontal-stepper class="mat-elevation-z4" [linear]="true">

                <mat-step [stepControl]="" >

                    <form fxLayout="column">

                        <ng-template matStepLabel>{{'REQUERIMIENTOS.PASO1.TITULO' | translate}}</ng-template>

                        <div fxFlex="1 0 auto" fxLayout="column">

                            <p class="pb-32">
                                <code class="titulo_text">{{'REQUERIMIENTOS.PASO1.SUB_TITULO' | translate}}</code>
                            </p>
                            <table id="myTable">
                                <tr>
                                    <td style="width:60%; background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO1.TABLE_REQUERIMIENTOS.TD_SISTEMAS' | translate}}</td>
                                    <td style="width:40%;">• Microsoft Windows 7 {{'REQUERIMIENTOS.PASO1.TABLE_REQUERIMIENTOS.TD_LABEL_RECOMENDADO' | translate}}<br> • MacOS 10.10.5 <br> • Android 6.0 {{'REQUERIMIENTOS.PASO1.TABLE_REQUERIMIENTOS.TD_LABEL_SUPERIOR' | translate}}
                                        <br> • iOs 7.1.2 {{'REQUERIMIENTOS.PASO1.TABLE_REQUERIMIENTOS.TD_LABEL_SUPERIOR' | translate}}<br>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO1.TABLE_REQUERIMIENTOS.TD_NAVEGADOR' | translate}}</td>
                                    <td>• Google Chrome {{'REQUERIMIENTOS.PASO1.TABLE_REQUERIMIENTOS.TD_LABEL_LASTVERSION' | translate}} <br> • Mozilla Firefox {{'REQUERIMIENTOS.PASO1.TABLE_REQUERIMIENTOS.TD_LABEL_LASTVERSION' | translate}} <br> • Apple Safari
                                        {{'REQUERIMIENTOS.PASO1.TABLE_REQUERIMIENTOS.TD_LABEL_LASTVERSION_MIN' | translate}}<br> • Microsoft Edge<br>
                                    </td>
                                </tr>

                            </table>
                            <br>
                            <p class="pb-32">
                                {{'REQUERIMIENTOS.PASO1.PARRAFO1.SUBPARRAFO1' | translate}}
                                <br><br> {{'REQUERIMIENTOS.PASO1.PARRAFO1.SUBPARRAFO2' | translate}}

                            </p>
                            <div class="message-box error">
                                {{'REQUERIMIENTOS.PASO1.ADVERT' | translate}}
                            </div>
                        </div>

                        <div fxFlex="1 0 auto" fxLayout="column">

                            <p class="pb-32">
                                <code class="titulo_text">{{'REQUERIMIENTOS.PASO1.SUB_TITULO2' | translate}}</code>
                            </p>
                            <table id="myTable">
                                <tr>
                                    <td style="width:60%; background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO1.TABLE_REQUISITOS.TD_CERTIFICAR' | translate}}</td>
                                    <td style="width:40%;">{{'REQUERIMIENTOS.PASO1.TABLE_REQUISITOS.TD_CONTENT1' | translate}}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="background-color: #f1f1f1">JavaScript</td>
                                    <td>{{'REQUERIMIENTOS.PASO1.TABLE_REQUISITOS.TD_CONTENT2' | translate}}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO1.TABLE_REQUISITOS.TD_COOKIES' | translate}}</td>
                                    <td>{{'REQUERIMIENTOS.PASO1.TABLE_REQUISITOS.TD_CONTENT3' | translate}}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO1.TABLE_REQUISITOS.TD_CIFRADO' | translate}}</td>
                                    <td>{{'REQUERIMIENTOS.PASO1.TABLE_REQUISITOS.TD_CONTENT4' | translate}}
                                    </td>
                                </tr>

                            </table>
                            <br>
                            <p class="pb-32">
                                <code class="titulo_text">{{'REQUERIMIENTOS.PASO2.SUB_TITULO1' | translate}}</code>
                            </p>
                            <p class="pb-32">
                                {{'REQUERIMIENTOS.PASO2.PARRAFO1' | translate}}

                            </p>

                            <p class="pb-32">
                                <code class="titulo_text">{{'REQUERIMIENTOS.PASO2.SUB_TITULO2' | translate}}</code>
                            </p>
                            <p class="pb-32">
                                {{'REQUERIMIENTOS.PASO2.PARRAFO2.LINEA1' | translate}}<br><br> {{'REQUERIMIENTOS.PASO2.PARRAFO2.LINEA2' | translate}}<br><br> {{'REQUERIMIENTOS.PASO2.PARRAFO2.LINEA3' | translate}}


                            </p>

                            <p class="pb-32">
                                <code class="titulo_text">{{'REQUERIMIENTOS.PASO2.SUB_TITULO3' | translate}}</code>
                            </p>
                            <p class="pb-32">
                                {{'REQUERIMIENTOS.PASO2.PARRAFO3' | translate}}<br>

                            </p>
                            <div class="message-box success">
                                {{'REQUERIMIENTOS.PASO2.PARRAFO4' | translate}}
                            </div>
                            <p class="pb-32">
                                {{'REQUERIMIENTOS.PASO2.PARRAFO5' | translate}}
                            </p>
                            <div class="message-box warning">
                                {{'REQUERIMIENTOS.PASO2.PARRAFO6' | translate}}
                            </div>
                            <p class="pb-32">
                                {{'REQUERIMIENTOS.PASO2.PARRAFO7.LINEA1' | translate}}<br><br> {{'REQUERIMIENTOS.PASO2.PARRAFO7.LINEA2' | translate}}
                                <br><br> {{'REQUERIMIENTOS.PASO2.PARRAFO7.LINEA3' | translate}}
                            </p>

                        </div>

                        <div fxLayout="row" fxLayoutAlign="center center">
                            <button mat-raised-button matStepperNext type="button" color="accent">
                {{'REQUERIMIENTOS.BOTONES.SIGUIENTE' | translate}}
              </button>
                        </div>

                    </form>

                </mat-step>


                <mat-step [stepControl]="" >

                    <form fxLayout="column">

                        <ng-template matStepLabel>{{'REQUERIMIENTOS.PASO2.TITULO' | translate}}</ng-template>

                        <div fxFlex="1 0 auto" fxLayout="column">


                            <p class="pb-32">
                                <code class="titulo_text">{{'REQUERIMIENTOS.PASO2.SUB_TITULO4' | translate}}</code>
                            </p>
                            <p class="pb-32">
                                {{'REQUERIMIENTOS.PASO2.PARRAFO8.LINEA1' | translate}}<br><br> {{'REQUERIMIENTOS.PASO2.PARRAFO8.LINEA2' | translate}}<br><br> {{'REQUERIMIENTOS.PASO2.PARRAFO8.LINEA3' | translate}}<br><br> {{'REQUERIMIENTOS.PASO2.PARRAFO8.LINEA4'
                                | translate}}<br><br> {{'REQUERIMIENTOS.PASO2.PARRAFO8.LINEA5' | translate}}<br><br> {{'REQUERIMIENTOS.PASO2.PARRAFO8.LINEA6' | translate}}<br><br> {{'REQUERIMIENTOS.PASO2.PARRAFO8.LINEA7' | translate}}

                            </p>

                            <p class="pb-32">
                                <code class="titulo_text">{{'REQUERIMIENTOS.PASO2.SUB_TITULO5' | translate}}</code>
                            </p>
                            <p class="pb-32">
                                {{'REQUERIMIENTOS.PASO2.PARRAFO9.LINEA1' | translate}}<br><br> {{'REQUERIMIENTOS.PASO2.PARRAFO9.LINEA2' | translate}}<br><br> {{'REQUERIMIENTOS.PASO2.PARRAFO9.LINEA3' | translate}}<br><br> {{'REQUERIMIENTOS.PASO2.PARRAFO9.LINEA4'
                                | translate}}
                            </p>

                            <div class="message-box warning">
                                {{'REQUERIMIENTOS.PASO2.PARRAFO10' | translate}}
                            </div>

                        </div>

                        <br>
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <button class="mr-8" mat-raised-button matStepperPrevious type="button" color="accent">
                {{'REQUERIMIENTOS.BOTONES.ANTERIOR' | translate}}
              </button>
                            <button mat-raised-button matStepperNext type="button" color="accent">
                {{'REQUERIMIENTOS.BOTONES.SIGUIENTE' | translate}}
              </button>
                        </div>

                    </form>

                </mat-step>

                <mat-step [stepControl]="">

                    <form fxLayout="column">

                        <ng-template matStepLabel>{{'REQUERIMIENTOS.PASO3.TITULO' | translate}}</ng-template>

                        <div fxFlex="1 0 auto" fxLayout="column">

                            <p class="pb-32">
                                <code class="titulo_text">{{'REQUERIMIENTOS.PASO3.SUB_TITULO1' | translate}}</code>
                            </p>
                            <p class="pb-32">
                                {{'REQUERIMIENTOS.PASO3.PARRAFO1' | translate}}
                            </p>
                            <p class="pb-32">
                                <code class="titulo_text">{{'REQUERIMIENTOS.PASO3.SUB_TITULO2' | translate}}</code>
                            </p>
                            <p class="pb-32">
                                {{'REQUERIMIENTOS.PASO3.PARRAFO2' | translate}}
                            </p>
                            <p class="pb-32">
                                <code class="titulo_text">{{'REQUERIMIENTOS.PASO3.SUB_TITULO3' | translate}}</code>
                            </p>
                            <p class="pb-32">
                                {{'REQUERIMIENTOS.PASO3.PARRAFO3.LINEA1' | translate}}<br><br> {{'REQUERIMIENTOS.PASO3.PARRAFO3.LINEA2' | translate}}
                            </p>

                            <!--<table id="myTable">
                                <tr>
                                    <td style="width:30%; background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO3.TABLA1.TD_ELEMENTO' | translate}}</td>
                                    <td style="width:30%; background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO3.TABLA1.TD_REGION1' | translate}}</td>
                                    <td style="width:30%; background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO3.TABLA1.TD_REGION2' | translate}}</td>
                                    <td style="width:30%; background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO3.TABLA1.TD_REGION3' | translate}}</td>
                                    <td style="width:30%; background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO3.TABLA1.TD_REGION4' | translate}}</td>
                                </tr>
                                <tr>
                                    <td style="background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO3.TABLA1.TD_DOMINIO' | translate}} </td>
                                    <td>cuturalgo.com</td>
                                    <td>cullturalgo.com</td>
                                    <td>culturalgo.com</td>
                                    <td>culturalgo.com</td>
                                </tr>
                                <tr>
                                    <td style="background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO3.TABLA1.TD_SUBDOMINIO' | translate}} </td>
                                    <td>survey01 .culturalgo.com</td>
                                    <td>survey02 .culturalgo.com</td>
                                    <td>survey04 .culturalgo.com</td>
                                    <td>survey05 .culturalgo.com</td>
                                </tr>
                                <tr>
                                    <td style="background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO3.TABLA1.TD_DIRECCION' | translate}} </td>
                                    <td>35.238.114.69 </td>
                                    <td>35.202.34.40 </td>
                                    <td>35.247.154.187 </td>
                                    <td>35.246.186.214</td>
                                </tr>
                                <tr>
                                    <td style="background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO3.TABLA1.TD_PUERTOS' | translate}} </td>
                                    <td>443 8080</td>
                                    <td>443 8080</td>
                                    <td>443 8080</td>
                                    <td>443 8080</td>
                                </tr>


                            </table>-->
                            <p class="pb-32" style="font-weight: bolder;">
                                {{'REQUERIMIENTOS.PASO3.TITLE1' | translate}}<br>
                            </p>
                            <table id="myTable">
                                <tr>
                                    <td style="width:30%; background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO3.TABLADOMINIO.TD_ELEMENTO05' | translate}}</td>
                                    <td style="width:30%; background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO3.TABLADOMINIO.TD_ELEMENTO03' | translate}}</td>
                                    <td style="width:30%; background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO3.TABLADOMINIO.TD_ELEMENTO04' | translate}}</td>
                                </tr>

                                <tr>
                                    <td>back04.culturalgo.com</td>
                                    <td>35.197.141.96</td>
                                    <td>8443</td>
                                </tr>
                                <tr>
                                    <td>culture04.culturalgo.com</td>
                                    <td>34.87.6.204</td>
                                    <td>8443</td>
                                </tr>
                                <tr>
                                    <td>app04.culturalgo.com</td>
                                    <td>35.247.131.159</td>
                                    <td>443</td>
                                </tr>
                                <tr>
                                    <td>graphics04.culturalgo.com</td>
                                    <td>34.87.16.113</td>
                                    <td>8443</td>
                                </tr>
                                <tr>
                                    <td>newsurvey.culturalgo.com/</td>
                                    <td>35.247.154.187</td>
                                    <td>443</td>
                                </tr>
                                <tr *ngIf="tipoProductoNorma">
                                    <td>surveyn35.culturalgo.com/</td>
                                    <td>35.247.154.187</td>
                                    <td>443</td>
                                </tr>
                                <!--<tr>
                                    <td>gptw.global</td>
                                    <td>35.240.163.121</td>
                                    <td>80</td>
                                </tr>-->
                            </table>
                            <p class="pb-32" style="font-weight: bolder;">
                                <br>{{'REQUERIMIENTOS.PASO3.TITLE2' | translate}}<br>
                            </p>
                            <table id="myTable">
                                <tr>
                                    <td style="width:30%; background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO3.TABLADOMINIO.TD_ELEMENTO05' | translate}}</td>
                                    <td style="width:30%; background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO3.TABLADOMINIO.TD_ELEMENTO03' | translate}}</td>
                                    <td style="width:30%; background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO3.TABLADOMINIO.TD_ELEMENTO04' | translate}}</td>
                                </tr>
                                <tr>
                                    <td>gptw.global</td>
                                    <td>35.240.163.121</td>
                                    <td>80</td>
                                </tr>
                                <tr>
                                    <td>4all.gptw.global </td>
                                    <td>35.240.163.121</td>
                                    <td>443</td>
                                </tr>
                                <!--<tr>
                                    <td>urlservices.culturalgo.com</td>
                                    <td>35.240.209.121</td>
                                    <td>443</td>
                                </tr>-->
                            </table><br>
                            <div class="message-box warning">
                                {{'REQUERIMIENTOS.PASO3.PARRAFO31' | translate}}
                            </div>
                            <p class="pb-32">
                                <code class="titulo_text">{{'REQUERIMIENTOS.PASO3.SUB_TITULO4' | translate}}</code>
                            </p>
                            <p class="pb-32">
                                {{'REQUERIMIENTOS.PASO3.PARRAFO4.LINEA1' | translate}}<br><br> {{'REQUERIMIENTOS.PASO3.PARRAFO4.LINEA2' | translate}}

                            </p>


                            <table id="myTable">
                                <tr>
                                    <td style="width:30%; background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO3.TABLA2.TD2' | translate}}</td>
                                    <td style="width:30%; background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO3.TABLADOMINIO.TD_ELEMENTO03' | translate}}</td>
                                </tr>
                                <tr>
                                    <td>gptwonline.com</td>
                                    <td>168.245.22.233</td>
                                </tr>
                                <tr>
                                    <td>em429.gptwonline.com</td>
                                    <td>149.72.154.98</td>
                                </tr>
                                <tr>
                                    <td>em2877.gptwonline.com</td>
                                    <td>149.72.190.59</td>
                                </tr>
                                <tr>
                                    <td>em7632.gptwonline.com</td>
                                    <td>168.245.113.112</td>
                                </tr>
                            </table>
                            <table id="myTable" style="padding-top: 7px!important;">
                                <tr>
                                    <td>{{'REQUERIMIENTOS.PASO3.TABLA2.TD1' | translate}} </td>
                                    <td>non-reply@gptwonline.com</td>
                                </tr>
                            </table>

                            <p class="pb-32">
                                {{'REQUERIMIENTOS.PASO3.PARRAFO5.LINEA1' | translate}}<br><br> {{'REQUERIMIENTOS.PASO3.PARRAFO5.LINEA2' | translate}}<br><br> {{'REQUERIMIENTOS.PASO3.PARRAFO5.LINEA3' | translate}}<br><br> {{'REQUERIMIENTOS.PASO3.PARRAFO5.LINEA4'
                                | translate}}
                            </p>
                            <p class="pb-32">
                                <code class="titulo_text">{{'REQUERIMIENTOS.PASO3.SUB_TITULO5' | translate}}</code>
                            </p>
                            <p class="pb-32">
                                {{'REQUERIMIENTOS.PASO3.PARRAFO6' | translate}}
                            </p>
                            <div class="message-box warning">
                                {{'REQUERIMIENTOS.PASO3.PARRAFO7' | translate}}
                            </div>
                            <br>
                        </div>

                        <div fxLayout="row" fxLayoutAlign="center center">
                            <button class="mr-8" mat-raised-button matStepperPrevious type="button" color="accent">
                {{'REQUERIMIENTOS.BOTONES.ANTERIOR' | translate}}
              </button>
                            <button mat-raised-button matStepperNext type="button" color="accent">
                {{'REQUERIMIENTOS.BOTONES.SIGUIENTE' | translate}}
              </button>
                        </div>

                    </form>

                </mat-step>

                <mat-step>

                    <ng-template matStepLabel>{{'REQUERIMIENTOS.PASO4.TITULO' | translate}}</ng-template>

                    <div fxFlex="1 0 auto" fxLayout="column">

                        <p class="pb-32">
                            <code class="titulo_text">{{'REQUERIMIENTOS.PASO4.SUB_TITULO1' | translate}}</code>
                        </p>
                        <table id="myTable">
                            <tr>
                                <td style="width:30%; background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO4.TABLA1.TD_REGION1' | translate}}</td>
                                <td>soporte-mx@gptwonline.com</td>
                            </tr>
                            <tr>
                                <td style="width:30%; background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO4.TABLA1.TD_REGION2' | translate}}</td>
                                <td>soporte-latam@gptwonline.com</td>
                            </tr>
                            <tr>
                                <td style="width:30%; background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO4.TABLA1.TD_REGION3' | translate}}</td>
                                <td> support-asia@gptwonline.com</td>
                            </tr>
                            <tr>
                                <td style="width:30%; background-color: #f1f1f1">{{'REQUERIMIENTOS.PASO4.TABLA1.TD_REGION4' | translate}}</td>
                                <td>support-ue@gptwonline.com</td>
                            </tr>
                        </table><br>
                        <p class="pb-32">
                            <code class="titulo_text">{{'REQUERIMIENTOS.PASO4.SUB_TITULO2' | translate}}</code>
                        </p>
                        <p class="pb-32">
                            {{'REQUERIMIENTOS.PASO4.PARRAFO1.LINEA1' | translate}}<br><br> {{'REQUERIMIENTOS.PASO4.PARRAFO1.LINEA2' | translate}}
                        </p>
                        <p class="pb-32">
                            <code class="titulo_text">{{'REQUERIMIENTOS.PASO4.SUB_TITULO3' | translate}}</code>
                        </p>
                        <p class="pb-32">
                            {{'REQUERIMIENTOS.PASO4.PARRAFO2' | translate}}
                        </p>
                        <div class="message-box warning">
                            {{'REQUERIMIENTOS.PASO4.PARRAFO3' | translate}}
                        </div>
                        <p class="pb-32">
                            <code class="titulo_text">{{'REQUERIMIENTOS.PASO4.SUB_TITULO4' | translate}}</code>
                        </p>
                        <p class="pb-32">
                            {{'REQUERIMIENTOS.PASO4.PARRAFO4' | translate}}
                        </p>
                        <p class="pb-32">
                            <code class="titulo_text">{{'REQUERIMIENTOS.PASO4.SUB_TITULO5' | translate}}</code>
                        </p>
                        <p class="pb-32">
                            {{'REQUERIMIENTOS.PASO4.PARRAFO5.LINEA1' | translate}}<br><br> {{'REQUERIMIENTOS.PASO4.PARRAFO5.LINEA2' | translate}}<br><br> {{'REQUERIMIENTOS.PASO4.PARRAFO5.LINEA3' | translate}}

                        </p>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="center center">
                        <button class="mr-8" mat-raised-button matStepperPrevious type="button" color="accent">
              {{'REQUERIMIENTOS.BOTONES.ANTERIOR' | translate}}
            </button>
                        <button mat-raised-button matStepperNext type="button" color="accent">
              {{'REQUERIMIENTOS.BOTONES.SIGUIENTE' | translate}}
            </button>
                    </div>

                </mat-step>
                <mat-step>

                    <ng-template matStepLabel>{{'REQUERIMIENTOS.PASO5.TITULO' | translate}}</ng-template>

                    <div fxFlex="1 0 auto" fxLayout="column">

                        <p class="pb-32">
                            <code class="titulo_text">{{'REQUERIMIENTOS.PASO5.SUB_TITULO1' | translate}}</code>
                        </p>

                        <p class="pb-32">
                            {{'REQUERIMIENTOS.PASO5.PARRAFO1' | translate}}
                        </p>

                    </div>

                    <div fxLayout="row" fxLayoutAlign="center center">
                        <button class="mr-8" mat-raised-button matStepperPrevious type="button" color="accent">
              {{'REQUERIMIENTOS.BOTONES.ANTERIOR' | translate}}
            </button>
                        <button *ngIf="!bandera" mat-raised-button type="button" color="accent" (click)="setBandera();">
              {{'REQUERIMIENTOS.BOTONES.ACEPTAR' | translate}}
            </button>
                    </div>

                </mat-step>

            </mat-horizontal-stepper>
            <!-- / HORIZONTAL STEPPER EXAMPLE -->

        </div>





    </div>
    <!-- / CONTENT -->

</div>
